import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { isValidPatientId } from "utils/isValidPatientId";

export const useConsultationsPaginatedList = ({
  patientId,
  page,
  search,
  rows = 10,
}) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["consultationsList", patientId, tenantVal, page, search, rows],
    queryFn: async () => {
      if (!isValidPatientId(patientId)) return null;

      const axiosInstance = await createAxiosInstance();
      const urlConsult =
        search !== undefined && search.length > 0
          ? `${tenantVal}/consultation/getbypatientid/${patientId}/details/search/page/${search.replace(/\//g, '-')}?page=${page}&rows=${rows}`
          : `${tenantVal}/consultation/getbypatientid/${patientId}/details/search/page?page=${page}&rows=${rows}`;
      const response = await axiosInstance.get(urlConsult);
      return response.data;
    },
    enabled: isValidPatientId(patientId) && !!tenantVal,
    staleTime: 1000 * 60 * 5,
    meta: { errorMessage: "Error fetching my consultations" },
  });
};

export const useMyConsultationsPaginatedList = ({ page, search, rows = 10 }) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["myConsultationsPaginatedList", tenantVal, page, search, rows],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        search.length < 3
          ? `${tenantVal}/consultation/myconsultations/open/page?page=${page}&rows=${rows}`
          : `${tenantVal}/consultation/myconsultations/open/search/page/${search.replace(/\//g, '-')}?page=${page}&rows=${rows}`
      );
      return response.data;
    },
    enabled: !!tenantVal,
    staleTime: 1000 * 60 * 5,
    meta: { errorMessage: "Error fetching my consultations" },
  });
};
